export interface EntityResourceContainer<T = Record<string, any>> {
  refId: number;
  type: ENTITY_TYPE;
  data: T;
  isLoading: boolean;
  isDirty: boolean;
}

export interface EntityStore<T extends EntityResourceContainer> {
  entities: T[];
}

export interface EntityRequestData<T extends EntityResourceContainer> {
  [key: string]: Omit<T, 'isLoading' | 'isDirty'>;
}

export enum ENTITY_TYPE {
  CLIENT = 'client',
}
